import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WeblinksEntity } from '../state/weblinks.models';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';

@Injectable({
  providedIn: 'root',
})
export class WeblinksService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  performPostRequest(language: string): Observable<{ weblinks: WeblinksEntity[] }> {
    const url = this.apiData.apiURL + `api/${this.client}/weblinks/` + language;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post<{ weblinks: WeblinksEntity[] }>(url, {}, { headers });
  }
}
